import HeaderMenu from 'components/Header/HeaderMenu';
import { SITE } from 'config/config';
import { twMerge } from 'tailwind-merge';
import MatchResult from './MatchResult';

const PrizeStructure = () => {
  return (
    <div className={twMerge(SITE, 'w-full min-h-full')}>
      <div className="relative z-10 pb-5">
        <HeaderMenu />
        <div className="container relative px-2 z-10">
          <MatchResult />
        </div>
      </div>{' '}
    </div>
  );
};

export default PrizeStructure;
